import Oauth from '../auth' //session control file
import notify from 'devextreme/ui/notify'
import appInfo from '../app-info'
var _ = require('lodash')
var api = {
    url: () => {
        return appInfo.WEBSERVICE_URL
    },
    get: async(url, request) => {
        //Objeto para peticiones GET , recibe dos variables url->Nombre del método(Obligatorio) request->Datos dentro de un objeto {}
        const datos = api.get_data(request) //Conversión de datos para envio tipo GET
        return await fetch(api.url() + url + datos, {
                //url del webservirses + url del método + datos enviados por GET
                method: 'GET', //Método
                header: api.user_auth(),
                mode: 'cors', //Objeto para la autenticación con el servidor
            })
            .then((res) => res.json()) //Conversión de la salida a datos JSON
            .catch((error) => {
                //Promesa de error
                notify({
                        message: 'Not connected to the Internet. Please check your connection and try again.',
                        width: 'auto',
                        shading: true,
                        position: 'center center',
                    },
                    'error',
                    3000
                )
                return Promise.reject(error)
            })
            .then((response) => {
                if (!_.has(response, 'STATUS_CODE')) {
                    //Promesa de respuesta
                    console.error('Error de conexión', response)
                    return Promise.reject(response)
                }
                return Promise.resolve(response)
            })
    },
    post: async(url, request) => {
        request = api.post_data(request)
            //Objeto para peticiones POST,recibe dos variables url->Nombre del método(Obligatorio) request->Datos dentro de un objeto {}
        return await fetch(api.url() + url, {
                //url del webservirses + url del método
                method: 'POST', //Método
                body: request, //Datos que se envian, convertidos a JSON
                header: api.user_auth(), //Objeto para la autenticación con el servidor
                mode: 'cors',
            })
            .then((res) => res.json()) //Conversión de la salida a datos JSON
            .catch((error) => {
                //Promesa de error
                notify({
                        message: 'Not connected to the Internet. Please check your connection and try again.',
                        width: 'auto',
                        shading: true,
                        position: 'center center',
                    },
                    'error',
                    3000
                )
                return Promise.reject(error)
            })
            .then((response) => {
                if (!_.has(response, 'STATUS_CODE')) {
                    //Promesa de respuesta
                    console.error('Error de conexión', response)
                    return Promise.reject(response)
                }
                return Promise.resolve(response)
            })
    },
    put: (url, request) => {
        request = api.post_data(request)
        return fetch(api.url() + url, {
                //Objeto para peticiones PUT,recibe dos variables url->Nombre del método(Obligatorio) request->Datos dentro de un objeto {}
                method: 'PUT', //Método
                header: api.user_auth(), //Objeto para la autenticación con el servidor
                body: request,
                mode: 'cors', //Datos que se envian, convertidos a JSON
            })
            .then((res) => res.json()) //Conversión de la salida a datos JSON
            .catch((error) => {
                //Promesa de error
                notify({
                        message: 'Not connected to the Internet. Please check your connection and try again.',
                        width: 'auto',
                        shading: true,
                        position: 'center center',
                    },
                    'error',
                    3000
                )
                return Promise.reject(error)
            })
            .then((response) => {
                //Promesa de respuesta
                if (!_.has(response, 'STATUS_CODE')) {
                    console.error('Error de conexión', response)
                    return Promise.reject(response)
                }
                return Promise.resolve(response)
            })
    },
    patch: (url, request) => {
        request = api.post_data(request)
        return fetch(api.url() + url, {
                //Objeto para peticiones PATCH,recibe dos variables url->Nombre del método(Obligatorio) request->Datos dentro de un objeto {}
                method: 'PATCH', //Método
                body: request, //Conversión de la salida a datos JSON
                header: api.user_auth(),
                mode: 'cors', //Objeto para la autenticación con el servidor
            })
            .then((res) => res.json()) //Conversión de la salida a datos JSON
            .catch((error) => {
                //Promesa de error
                notify({
                        message: 'Not connected to the Internet. Please check your connection and try again.',
                        width: 'auto',
                        shading: true,
                        position: 'center center',
                    },
                    'error',
                    3000
                )
                return Promise.reject(error)
            })
            .then((response) => {
                //Promesa de respuesta
                if (!_.has(response, 'STATUS_CODE')) {
                    console.error('Error de conexión', response)
                    return Promise.reject(response)
                }
                return Promise.resolve(response)
            })
    },
    delete: (url, request) => {
        request = api.post_data(request)
        return fetch(api.url() + url, {
                //Objeto para peticiones DELETE,recibe dos variables url->Nombre del método(Obligatorio) request->Datos dentro de un objeto {}
                method: 'DELETE', //Método
                header: api.user_auth(), //Objeto para la autenticación con el servidor
                body: request, //Conversión de la salida a datos JSON
                mode: 'cors',
            })
            .then((res) => res.json()) //Promesa de error
            .catch((error) => {
                notify({
                        message: 'Not connected to the Internet. Please check your connection and try again.',
                        width: 'auto',
                        shading: true,
                        position: 'center center',
                    },
                    'error',
                    3000
                )
                return Promise.reject(error)
            })
            .then((response) => {
                //Promesa de respuesta
                if (!_.has(response, 'STATUS_CODE')) {
                    console.error('Error de conexión', response)
                    return Promise.reject(response)
                }
                return Promise.resolve(response)
            })
    },
    get_data: (data) => {
        //Función que convierte los datos de envio de tipo GET a estructura tipo URL
        let contador = 0
        let datos = ''
        for (var key in data) {
            datos += contador == 0 ? '?' : '&'
            datos += key + '=' + data[key]
            contador++
        }
        datos += contador == 0 ? '?' : '&'
        datos += '&user_id' + '=' + Oauth.get_user_id()
        datos += '&token' + '=' + Oauth.get_token()
        datos += '&lang' + '=' + Oauth.get_language()


        return datos
    },
    post_data: (data) => {
        const formData = new FormData()
        for (var key in data) {
            formData.append(key, data[key])
        }
        formData.append('user_id', Oauth.get_user_id())
        formData.append('token', Oauth.get_token())
        formData.append('lang', Oauth.get_language())
        return formData
    },
    user_auth: () => {
        //Objeto de autenticación
        var header = {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': 'true',
            'Content-Type': 'application/x-www-form-urlencoded',
        }
        return header
    },
}
export default api